@if (review; as gc) {
  <div class="guardian-review">
    <div class="guardian-review__grid">
      <div class="guardian-review__item">
        <div class="guardian-review__label">Current Parent Name</div>
        <div class="guardian-review__value">{{ gc.currentParentName || '—' }}</div>
      </div>
      <div class="guardian-review__item">
        <div class="guardian-review__label">New Parent First Name</div>
        <div class="guardian-review__value">{{ gc.newParentFirstName || '—' }}</div>
      </div>
      <div class="guardian-review__item">
        <div class="guardian-review__label">New Parent Last Name</div>
        <div class="guardian-review__value">{{ gc.newParentLastName || '—' }}</div>
      </div>
      <div class="guardian-review__item">
        <div class="guardian-review__label">New Parent Date of Birth</div>
        <div class="guardian-review__value">
          {{ gc.newParentDateOfBirth ? (gc.newParentDateOfBirth | date: 'MM/dd/yyyy') : '—' }}
        </div>
      </div>
      <div class="guardian-review__item">
        <div class="guardian-review__label">New Parent Email</div>
        <div class="guardian-review__value">{{ gc.newParentEmail || '—' }}</div>
      </div>
      <div class="guardian-review__item">
        <div class="guardian-review__label">New Parent PID</div>
        <div class="guardian-review__value">{{ gc.newParentPid || '—' }}</div>
      </div>
      @if (gc.newParentPhone) {
        <div class="guardian-review__item">
          <div class="guardian-review__label">New Parent Phone</div>
          <div class="guardian-review__value">{{ gc.newParentPhone }}</div>
        </div>
      }
      <div class="guardian-review__item guardian-review__item--full">
        <div class="guardian-review__label">Selected Student(s)</div>
        <div class="guardian-review__value">
          @if (selectedStudentDisplays.length > 0) {
            <ul class="guardian-review__students">
              @for (student of selectedStudentDisplays; track student.studentId) {
                <li>
                  {{ student.name }}@if (student.pid) {<span> | PID: {{ student.pid }}</span>}
                </li>
              }
            </ul>
          } @else {
            —
          }
        </div>
      </div>
    </div>
  </div>
} @else {
  <div class="padding-1rem">No form data available.</div>
}
